/**
 * Comprehensive Phrases Data - Time & Place
 * 时间和地点短语集合
 *
 * 包含时间表达和地点描述，约40个短语
 */

import { Phrase } from './phrases-types';

export const timePlacePhrases: Phrase[] = [
  // ==================== 时间表达 Time Expressions ====================

  // 一天中的时间
  {
    id: 'time_in_the_morning',
    phrase: 'in the morning',
    phonetic: '/ɪn ðə ˈmɔːrnɪŋ/',
    meaning: '在早上',
    usageScenario: '描述早上发生的事情或习惯，通常指上午时段',
    example: 'I eat breakfast in the morning.',
    exampleTranslation: '我早上吃早餐。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_in_the_afternoon',
    phrase: 'in the afternoon',
    phonetic: '/ɪn ðə ˌæftərˈnuːn/',
    meaning: '在下午',
    usageScenario: '描述下午发生的事情或习惯，通常指中午12点到下午6点',
    example: 'We have English class in the afternoon.',
    exampleTranslation: '我们下午有英语课。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_in_the_evening',
    phrase: 'in the evening',
    phonetic: '/ɪn ðə ˈiːvnɪŋ/',
    meaning: '在晚上',
    usageScenario: '描述晚上发生的事情或习惯，通常指下午6点之后',
    example: 'I watch TV in the evening.',
    exampleTranslation: '我晚上看电视。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_at_night',
    phrase: 'at night',
    phonetic: '/æt naɪt/',
    meaning: '在夜里',
    usageScenario: '描述夜间发生的事情，注意用at而不是in',
    example: 'I sleep at night.',
    exampleTranslation: '我晚上睡觉。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_at_noon',
    phrase: 'at noon',
    phonetic: '/æt nuːn/',
    meaning: '在中午',
    usageScenario: '描述中午12点发生的事情',
    example: 'We have lunch at noon.',
    exampleTranslation: '我们中午吃午饭。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_at_midnight',
    phrase: 'at midnight',
    phonetic: '/æt ˈmɪdnaɪt/',
    meaning: '在午夜',
    usageScenario: '描述半夜12点发生的事情',
    example: 'The party ends at midnight.',
    exampleTranslation: '聚会在午夜结束。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },

  // 星期
  {
    id: 'time_on_monday',
    phrase: 'on Monday',
    phonetic: '/ɒn ˈmʌndeɪ/',
    meaning: '在星期一',
    usageScenario: '描述星期一发生的事情，注意用on',
    example: 'I have English class on Monday.',
    exampleTranslation: '我星期一有英语课。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_tuesday',
    phrase: 'on Tuesday',
    phonetic: '/ɒn ˈtuːzdeɪ/',
    meaning: '在星期二',
    usageScenario: '描述星期二发生的事情',
    example: 'I play football on Tuesday.',
    exampleTranslation: '我星期二踢足球。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_wednesday',
    phrase: 'on Wednesday',
    phonetic: '/ɒn ˈwenzdeɪ/',
    meaning: '在星期三',
    usageScenario: '描述星期三发生的事情',
    example: 'We have a meeting on Wednesday.',
    exampleTranslation: '我们星期三有个会议。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_thursday',
    phrase: 'on Thursday',
    phonetic: '/ɒn ˈθɜːrzdeɪ/',
    meaning: '在星期四',
    usageScenario: '描述星期四发生的事情',
    example: 'I go swimming on Thursday.',
    exampleTranslation: '我星期四去游泳。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_friday',
    phrase: 'on Friday',
    phonetic: '/ɒn ˈfraɪdeɪ/',
    meaning: '在星期五',
    usageScenario: '描述星期五发生的事情',
    example: 'Friday is my favorite day.',
    exampleTranslation: '星期五是我最喜欢的一天。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_saturday',
    phrase: 'on Saturday',
    phonetic: '/ɒn ˈsætərdeɪ/',
    meaning: '在星期六',
    usageScenario: '描述星期六发生的事情，星期六是周末',
    example: "I don't go to school on Saturday.",
    exampleTranslation: '我星期六不去学校。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_sunday',
    phrase: 'on Sunday',
    phonetic: '/ɒn ˈsʌndeɪ/',
    meaning: '在星期日',
    usageScenario: '描述星期日发生的事情，星期日是周末',
    example: 'I go to the park on Sunday.',
    exampleTranslation: '我星期日去公园。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_on_weekends',
    phrase: 'on weekends',
    phonetic: '/ɒn ˈwiːkendz/',
    meaning: '在周末',
    usageScenario: '描述周末（星期六和星期日）发生的事情',
    example: 'I usually stay home on weekends.',
    exampleTranslation: '我周末通常待在家里。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // 月份和季节
  {
    id: 'time_in_january',
    phrase: 'in January',
    phonetic: '/ɪn ˈdʒænjuəri/',
    meaning: '在一月',
    usageScenario: '描述一月份发生的事情',
    example: 'My birthday is in January.',
    exampleTranslation: '我的生日在一月。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_in_february',
    phrase: 'in February',
    phonetic: '/ɪn ˈfebruəri/',
    meaning: '在二月',
    usageScenario: '描述二月份发生的事情',
    example: 'Chinese New Year is in February.',
    exampleTranslation: '中国新年通常在二月。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_in_spring',
    phrase: 'in spring',
    phonetic: '/ɪn sprɪŋ/',
    meaning: '在春天',
    usageScenario: '描述春季发生的事情',
    example: 'Flowers bloom in spring.',
    exampleTranslation: '春天花儿开放。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_in_summer',
    phrase: 'in summer',
    phonetic: '/ɪn ˈsʌmər/',
    meaning: '在夏天',
    usageScenario: '描述夏季发生的事情',
    example: 'We go swimming in summer.',
    exampleTranslation: '我们夏天去游泳。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_in_autumn',
    phrase: 'in autumn',
    phonetic: '/ɪn ˈɔːtəm/',
    meaning: '在秋天',
    usageScenario: '描述秋季发生的事情，也可以说in fall',
    example: 'Leaves fall in autumn.',
    exampleTranslation: '秋天树叶落下。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_in_winter',
    phrase: 'in winter',
    phonetic: '/ɪn ˈwɪntər/',
    meaning: '在冬天',
    usageScenario: '描述冬季发生的事情',
    example: 'It snows in winter.',
    exampleTranslation: '冬天下雪。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 其他时间表达
  {
    id: 'time_every_day',
    phrase: 'every day',
    phonetic: '/ˈevri deɪ/',
    meaning: '每天',
    usageScenario: '描述每天都会发生的事情',
    example: 'I study English every day.',
    exampleTranslation: '我每天都学英语。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_every_week',
    phrase: 'every week',
    phonetic: '/ˈevri wiːk/',
    meaning: '每周',
    usageScenario: '描述每周都会发生的事情',
    example: 'We have a meeting every week.',
    exampleTranslation: '我们每周都有会议。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_every_year',
    phrase: 'every year',
    phonetic: '/ˈevri jɪr/',
    meaning: '每年',
    usageScenario: '描述每年都会发生的事情',
    example: 'I visit my grandparents every year.',
    exampleTranslation: '我每年都去看望祖父母。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'time_this_week',
    phrase: 'this week',
    phonetic: '/ðɪs wiːk/',
    meaning: '这周',
    usageScenario: '描述本周发生的事情',
    example: 'I am very busy this week.',
    exampleTranslation: '我这周很忙。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_next_week',
    phrase: 'next week',
    phonetic: '/nekst wiːk/',
    meaning: '下周',
    usageScenario: '描述下周将发生的事情',
    example: "I'm going to Beijing next week.",
    exampleTranslation: '我下周要去北京。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'time_last_week',
    phrase: 'last week',
    phonetic: '/læst wiːk/',
    meaning: '上周',
    usageScenario: '描述上周发生的事情',
    example: 'I went to the zoo last week.',
    exampleTranslation: '我上周去了动物园。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 地点表达 Place Expressions ====================

  // 学校相关地点
  {
    id: 'place_at_school',
    phrase: 'at school',
    phonetic: '/æt skuːl/',
    meaning: '在学校',
    usageScenario: '描述在学校发生的事情或在学校的状态',
    example: 'I study at school.',
    exampleTranslation: '我在学校学习。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_the_classroom',
    phrase: 'in the classroom',
    phonetic: '/ɪn ðə ˈklæsruːm/',
    meaning: '在教室里',
    usageScenario: '描述在教室里发生的事情',
    example: 'There are many desks in the classroom.',
    exampleTranslation: '教室里有很多桌子。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_the_library',
    phrase: 'in the library',
    phonetic: '/ɪn ðə ˈlaɪbrəri/',
    meaning: '在图书馆里',
    usageScenario: '描述在图书馆发生的事情',
    example: 'I read books in the library.',
    exampleTranslation: '我在图书馆看书。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'place_on_the_playground',
    phrase: 'on the playground',
    phonetic: '/ɒn ðə ˈpleɪɡraʊnd/',
    meaning: '在操场上',
    usageScenario: '描述在操场发生的事情',
    example: 'We run on the playground.',
    exampleTranslation: '我们在操场上跑步。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 家庭相关地点
  {
    id: 'place_at_home',
    phrase: 'at home',
    phonetic: '/æt hoʊm/',
    meaning: '在家里',
    usageScenario: '描述在家里发生的事情或在家的状态',
    example: 'I am at home now.',
    exampleTranslation: '我现在在家里。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_my_room',
    phrase: 'in my room',
    phonetic: '/ɪn maɪ ruːm/',
    meaning: '在我的房间里',
    usageScenario: '描述在自己房间发生的事情',
    example: 'I do my homework in my room.',
    exampleTranslation: '我在房间里做作业。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_the_kitchen',
    phrase: 'in the kitchen',
    phonetic: '/ɪn ðə ˈkɪtʃɪn/',
    meaning: '在厨房里',
    usageScenario: '描述在厨房发生的事情',
    example: 'Mom cooks in the kitchen.',
    exampleTranslation: '妈妈在厨房做饭。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_the_bedroom',
    phrase: 'in the bedroom',
    phonetic: '/ɪn ðə ˈbedruːm/',
    meaning: '在卧室里',
    usageScenario: '描述在卧室发生的事情',
    example: 'I sleep in the bedroom.',
    exampleTranslation: '我在卧室睡觉。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_the_bathroom',
    phrase: 'in the bathroom',
    phonetic: '/ɪn ðə ˈbæθruːm/',
    meaning: '在浴室里',
    usageScenario: '描述在浴室发生的事情',
    example: 'I wash my hands in the bathroom.',
    exampleTranslation: '我在浴室洗手。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // 公共场所
  {
    id: 'place_in_the_park',
    phrase: 'in the park',
    phonetic: '/ɪn ðə pɑːrk/',
    meaning: '在公园里',
    usageScenario: '描述在公园发生的事情',
    example: 'We play in the park.',
    exampleTranslation: '我们在公园里玩。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_at_the_zoo',
    phrase: 'at the zoo',
    phonetic: '/æt ðə zuː/',
    meaning: '在动物园',
    usageScenario: '描述在动物园发生的事情',
    example: 'We saw many animals at the zoo.',
    exampleTranslation: '我们在动物园看到了很多动物。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'place_in_the_supermarket',
    phrase: 'in the supermarket',
    phonetic: '/ɪn ðə ˈsuːpərmɑːrkɪt/',
    meaning: '在超市里',
    usageScenario: '描述在超市购物的事情',
    example: 'We buy food in the supermarket.',
    exampleTranslation: '我们在超市买食物。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_at_the_station',
    phrase: 'at the station',
    phonetic: '/æt ðə ˈsteɪʃən/',
    meaning: '在车站',
    usageScenario: '描述在车站发生的事情',
    example: "I'll meet you at the station.",
    exampleTranslation: '我会在车站见你。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 交通相关
  {
    id: 'place_on_the_bus',
    phrase: 'on the bus',
    phonetic: '/ɒn ðə bʌs/',
    meaning: '在公共汽车上',
    usageScenario: '描述在公共汽车上的情况',
    example: 'I see my friend on the bus.',
    exampleTranslation: '我在公共汽车上看到了我的朋友。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'place_on_the_train',
    phrase: 'on the train',
    phonetic: '/ɒn ðə treɪn/',
    meaning: '在火车上',
    usageScenario: '描述在火车上的情况',
    example: 'I read books on the train.',
    exampleTranslation: '我在火车上看书。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 城市和地点
  {
    id: 'place_in_beijing',
    phrase: 'in Beijing',
    phonetic: '/ɪn beɪˈdʒɪŋ/',
    meaning: '在北京',
    usageScenario: '描述在北京的情况',
    example: 'I live in Beijing.',
    exampleTranslation: '我住在北京。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_shanghai',
    phrase: 'in Shanghai',
    phonetic: '/ɪn ʃæŋˈhaɪ/',
    meaning: '在上海',
    usageScenario: '描述在上海的情况',
    example: 'I visited Shanghai last year.',
    exampleTranslation: '我去年参观了上海。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'place_in_china',
    phrase: 'in China',
    phonetic: '/ɪn ˈtʃaɪnə/',
    meaning: '在中国',
    usageScenario: '描述在中国的情况',
    example: 'I live in China.',
    exampleTranslation: '我住在中国。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
];